import { __awaiter, __generator } from "tslib";
export var PaymentCycleType;
(function (PaymentCycleType) {
    PaymentCycleType[PaymentCycleType["ONE_TIME"] = 0] = "ONE_TIME";
    PaymentCycleType[PaymentCycleType["DAILY"] = 1] = "DAILY";
    PaymentCycleType[PaymentCycleType["WEEKLY"] = 2] = "WEEKLY";
    PaymentCycleType[PaymentCycleType["MONTHLY"] = 3] = "MONTHLY";
    PaymentCycleType[PaymentCycleType["QUARTERLY"] = 4] = "QUARTERLY";
    PaymentCycleType[PaymentCycleType["SEMI_ANNUALLY"] = 5] = "SEMI_ANNUALLY";
    PaymentCycleType[PaymentCycleType["YEARLY"] = 6] = "YEARLY";
    PaymentCycleType[PaymentCycleType["TWO_YEARS"] = 7] = "TWO_YEARS";
    PaymentCycleType[PaymentCycleType["THREE_YEARS"] = 8] = "THREE_YEARS";
})(PaymentCycleType || (PaymentCycleType = {}));
;
export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum[ProductTypeEnum["KNOWLEDGE_BASE"] = 1] = "KNOWLEDGE_BASE";
    ProductTypeEnum[ProductTypeEnum["TICKETS"] = 2] = "TICKETS";
    ProductTypeEnum[ProductTypeEnum["CALL_CENTER"] = 3] = "CALL_CENTER";
    ProductTypeEnum[ProductTypeEnum["CHAT"] = 4] = "CHAT";
    ProductTypeEnum[ProductTypeEnum["COMBO"] = 10] = "COMBO";
})(ProductTypeEnum || (ProductTypeEnum = {}));
;
export var PaymentCycleOptions;
(function (PaymentCycleOptions) {
    PaymentCycleOptions["MONTHLY"] = "MONTHLY";
    PaymentCycleOptions["YEARLY"] = "YEARLY";
})(PaymentCycleOptions || (PaymentCycleOptions = {}));
;
;
;
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["POSTED"] = "Posted";
    InvoiceStatus["DRAFT"] = "Draft";
    InvoiceStatus["CANCELED"] = "Canceled";
    InvoiceStatus["ERROR"] = "Error";
})(InvoiceStatus || (InvoiceStatus = {}));
;
;
;
export var BillingServiceProvider;
(function (BillingServiceProvider) {
    BillingServiceProvider[BillingServiceProvider["SBS"] = 1] = "SBS";
    BillingServiceProvider[BillingServiceProvider["ZUORA"] = 2] = "ZUORA";
})(BillingServiceProvider || (BillingServiceProvider = {}));
export var createAccountApi = function (baseUrl, http) {
    var accountsBase = "".concat(baseUrl, "/accounts");
    var billingBase = "".concat(baseUrl, "/billing");
    var filesBase = "".concat(baseUrl, "/files");
    var api = {
        purchaseUrl: "".concat(billingBase, "/purchase"),
        extendSession: function (sameSite) {
            return http.post("".concat(accountsBase, "/extend-session"), sameSite ? { sameSite: true } : {}); // temp solution for
        },
        acceptInvitation: function (token, firstName, lastName, email, password) {
            if (password === void 0) { password = ''; }
            return http.post("".concat(accountsBase, "/accept-invitation"), { token: token, firstName: firstName, lastName: lastName, email: email, password: password });
        },
        sendResetPassword: function (email) {
            return http.post("".concat(accountsBase, "/password/send-reset"), { email: email });
        },
        setPassword: function (token, newPassword) {
            return http.post("".concat(accountsBase, "/password/set"), { token: token, newPassword: newPassword });
        },
        getPurchaseData: function (data) {
            return http.post("".concat(billingBase, "/purchase"), data);
        },
        getCallCenterCreditBalance: function () {
            return http.get("".concat(billingBase, "/callcenter/balance"));
        },
        getCallCenterCreditPurchaseData: function (data) {
            return http.post("".concat(billingBase, "/purchase/callcenter"), data);
        },
        getPricingPlans: function () {
            return http.get("https://www.wixanswers.com/api/pricing-plans");
        },
        getPlan: function (_) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {}];
            });
        }); },
        pingRealTime: function () {
            return http.post("".concat(accountsBase, "/realtime/ping"), {});
        },
        getZuoraIframe: function (debug) {
            if (debug) {
                return http.get("".concat(billingBase, "/iframe?debug=").concat(debug));
            }
            return http.get("".concat(billingBase, "/iframe"));
        },
        confirmZuoraOrder: function (dto) {
            return http.post("".concat(billingBase, "/order"), dto);
        },
        previewZuoraOrder: function (dto) {
            return http.post("".concat(billingBase, "/order/preview"), dto);
        },
        purchaseCallCredits: function (dto) {
            return http.post("".concat(billingBase, "/order/callCredits"), dto);
        },
        getBillingProvider: function () {
            return http.get("".concat(billingBase, "/provider"));
        },
        getUserCountryCode: function () {
            var headers = { Accept: 'text/plain' };
            return http.get("".concat(baseUrl, "/users/me/geo/country"), headers);
        },
        isNameAvailable: function (name) {
            return http.post("".concat(baseUrl, "/tenants/nameAvailable"), { name: name });
        },
        getLatestInvoicesDetails: function () {
            return http.get("".concat(billingBase, "/invoices"));
        },
        downloadInvoice: function (invoiceId) {
            return "".concat(billingBase, "/invoices/").concat(invoiceId, "/download");
        },
        getDefaultPaymentMethod: function () {
            return http.get("".concat(billingBase, "/paymentMethods/default"));
        },
        replaceDefaultPaymentMethod: function (dto) {
            return http.post("".concat(billingBase, "/creditCards/replace"), dto);
        },
        getAnswersExportFiles: function () { return http.get("".concat(filesBase, "/listExportFiles")); },
        login: function (dto) { return http.post("".concat(accountsBase, "/login"), dto); },
        verifyEmail: function (dto) { return http.post("".concat(accountsBase, "/verify/email"), dto); },
    };
    return api;
};
//# sourceMappingURL=index.js.map